import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const exportOrderDetailToExcel = (data, filename) => {
    const workbook = XLSX.utils.book_new();

    // Create a worksheet for product list
    const productWorksheet = XLSX.utils.json_to_sheet(data?.productList);
    XLSX.utils.book_append_sheet(workbook, productWorksheet, 'Products');

    // Create a worksheet for additional information
    const additionalWorksheet = XLSX.utils.aoa_to_sheet([
        ['Id', 'Rep Name', 'Customer', 'Status', 'Comments', 'Date Created', 'Total Products'],
        [data.Id, data.Rep, data.Customer, data.Status, data?.Comments, data?.CreatedOn, data?.TotalProducts]
    ]);
    XLSX.utils.book_append_sheet(workbook, additionalWorksheet, 'Additional Info');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
